import React from 'react';
import TriggerAlert from './TriggerAlertUpdated.tsx';
import IotBattery from './IotBattery.tsx';
import TriggerStats from "./TriggerStats.tsx";
import DescriptionBox from "../../components/DescriptionBox/index.tsx";

const TriggerAlertPage = () => {
  return (
    <div className="flex flex-col gap-6">
      <TriggerAlert />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-[rgb(var(--border-primary))] rounded-lg bg-[rgb(var(--surface-1))] p-5 flex flex-col" style={{ height: "360px" }}>
          <DescriptionBox
            title="Devices"
            subTitle="Button Health"
            description="Battery status of push button devices."
          />
          <div className="mt-4 overflow-y-auto flex-1">
            <IotBattery />
          </div>
        </div>
        <div className="border border-[rgb(var(--border-primary))] rounded-lg bg-[rgb(var(--surface-1))] p-5 flex flex-col" style={{ height: "360px" }}>
          <DescriptionBox
            title="Analytics"
            subTitle="Trigger Statistics"
            description="Alert frequency and resolution metrics."
          />
          <div className="mt-4 flex-1 min-h-0">
            <TriggerStats />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TriggerAlertPage;
